import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  role: "list",
  class: "space-y-2 text-sm text-left items-start align-top hidden md:block",
  style: {"columns":"3"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "uppercase text-gray-400 pr-2 text-xs" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = {
  role: "list",
  class: "space-y-2 text-sm text-left items-start align-top md:hidden"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "uppercase text-gray-400 pr-2 text-xs" }
const _hoisted_8 = { class: "ml-2" }


import ConfItemDescriptionPartsSub from "@/components/conf/description/confItemDescriptionPartsSub.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'confItemDescriptionParts',
  props: ["partsList"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.partsList, (detail, detailIdx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: detailIdx,
          style: {"break-inside":"avoid-column"}
        }, [
          (detail.title !== '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(detail.title) + ":", 1),
                _createTextVNode(" " + _toDisplayString(detail.value), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ConfItemDescriptionPartsSub, {
              "sub-list": detail.sub
            }, null, 8, ["sub-list"])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.partsList, (detail, detailIdx) => {
        return (_openBlock(), _createElementBlock("li", { key: detailIdx }, [
          (detail.title !== '')
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(detail.title) + ":", 1),
                _createTextVNode(" " + _toDisplayString(detail.value), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(ConfItemDescriptionPartsSub, {
              "sub-list": detail.sub
            }, null, 8, ["sub-list"])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})